import React, { ReactElement, useCallback, useState } from 'react'

import { PdfPreloadContextProvider } from './contexts/pdfPreloadContext'
import { FilesPreviewContent, FilesPreviewContentProps } from './elements/FilesPreviewContent'
import { FullScreenPreview } from './elements/FullScreenPreview'

type FilesPreviewProps = Omit<FilesPreviewContentProps, 'onImageZoomClick'>

export const FilesPreview = (props: FilesPreviewProps): ReactElement => {
  const [isFullScreenMode, setIsFullScreenMode] = useState(false)

  const handleImageZoomClick = useCallback(() => {
    setIsFullScreenMode(true)
  }, [])

  const handleFullScreenCloseClick = useCallback(() => {
    setIsFullScreenMode(false)
  }, [])

  return (
    <PdfPreloadContextProvider asType={props.asType} files={props.files}>
      <FilesPreviewContent onImageZoomClick={handleImageZoomClick} {...props} />
      {props.withModalZoom && (
        <FullScreenPreview
          aspectRatio={props.aspectRatio}
          asType={props.asType}
          className={props.className}
          files={props.files}
          onClose={handleFullScreenCloseClick}
          visible={isFullScreenMode}
          withDownloadButton={props.withDownloadButton}
          withRotate={props.withRotate}
          withOverlay={props.withOverlay}
        />
      )}
    </PdfPreloadContextProvider>
  )
}
